import { render, staticRenderFns } from "./serveTab2.vue?vue&type=template&id=483a1646&scoped=true"
import script from "./serveTab2.vue?vue&type=script&lang=js"
export * from "./serveTab2.vue?vue&type=script&lang=js"
import style0 from "./serveTab2.vue?vue&type=style&index=0&id=483a1646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483a1646",
  null
  
)

export default component.exports